import React, { useEffect, useState } from "react";
import { Row, Col, Card, Button, Modal } from "react-bootstrap";
import { Icon } from "@iconify/react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import avatar1 from "../../assets/img/default.jpg";
import avatar2 from "../../assets/img/avatars/4.png";
import { userList, deleteUser } from "../../common/api";
import ConfigApp from "../../common/config";
import { format } from "date-fns";
import { ShowToast } from "../../common/function";
import { Sentry, Spinner } from "react-activity";
export default function Users() {
  const [searchText, setSearchText] = useState("");
  const [show, setShow] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [userId, setUserId] = useState("");
  const handleClose = () => setShow(false);
  const handleShow = (id) => {
    setShow(true);
    setUserId(id);
  };

  const getStatusStyle = (status) => {
    switch (status) {
      case "0":
        return {
          backgroundColor: "rgba(40, 199, 111, 0.12)",
          color: "#28c76f",
          padding: "5px 10px",
          borderRadius: "5px",
          display: "inline-block",
        };
      case "1":
        return {
          backgroundColor: "rgba(146, 0, 0, 0.12)",
          color: "#920000",
          padding: "5px 10px",
          borderRadius: "5px",
          display: "inline-block",
        };
      default:
        return {};
    }
  };

  const userListData = async () => {
    setLoading(true);
    const token = localStorage.getItem("token");

    const response = await userList(token);
    console.log("response", response);
    if (response.success == true) {
      const filteredUsers = response.body.filter(
        (user) =>
          user.full_name &&
          typeof user.full_name === "string" &&
          user.full_name.trim().length > 0
      );
      console.log("filteredUsers", filteredUsers);

      setDataList(filteredUsers);
      setLoading(false);
    }
  };
  useEffect(() => {
    userListData();
  }, []);

  const formatDate = (dateString) => {
    return format(new Date(dateString), "dd-MM-yyyy");
  };

  const handleDelete = async () => {
    setDeleteLoading(true);
    const token = localStorage.getItem("token");
    const payload = { userId };

    const response = await deleteUser(token, payload);
    console.log("response", response);
    if (response.success == true) {
      setDeleteLoading(false);
      ShowToast(1, response.message);
      userListData();
      handleClose();
    } else {
      ShowToast(0, response.message);
    }
  };

  const columns = [
    {
      name: "Sr. No.",
      width: "100px",
      selector: (row, index) => index + 1,
      sortable: true,
      cell: (row, index) => index + 1,
    },
    {
      name: "Name",
      minWidth: "220px",
      selector: (row) => row?.full_name,
      sortable: true,
      cell: (row) => (
        <>
          <img
            className="table_img rounded-circle img-thumbnail me-2"
            src={
              row.profile_url
                ? row.profile_url.startsWith("http")
                  ? row.profile_url
                  : `${ConfigApp.IMAGE_URL}${row.profile_url}`
                : avatar1
            }
            alt=""
          />
          {row?.full_name ? row?.full_name : "N/A"}
        </>
      ),
    },
    {
      name: "Email",
      minWidth: "190px",
      selector: (row) => row?.email,
      sortable: true,
      cell: (row) => (row?.email ? row?.email : "N/A"),
    },
    {
      name: "Type",
      minWidth: "100px",
      selector: (row) => row?.login_type,
      sortable: true,
      cell: (row) => (row?.login_type ? row?.login_type : "N/A"),
    },
    {
      name: "Wallet balance",
      minWidth: "190px",
      selector: (row) => row?.wallet?.total_balance,
      sortable: true,
      cell: (row) => (row?.wallet?.total_balance ? row?.wallet?.total_balance : "0"),
    },

    {
      name: "Spent balance",
      minWidth: "190px",
      selector: (row) => row?.wallet?.today_spend,
      sortable: true,
      cell: (row) => (row?.wallet?.today_spend ? row?.wallet?.today_spend : "0"),
    },
    {
      name: "Created On",
      minWidth: "150px",
      selector: (row) => formatDate(row?.createdAt),
      sortable: true,
      cell: (row) =>
        formatDate(row?.createdAt) ? formatDate(row?.createdAt) : "N/A",
    },
    {
      name: "Status",
      selector: (row) => (row?.is_active == "0" ? "Active" : "In Active"),
      sortable: true,
      cell: (row) => (
        <span style={getStatusStyle(row?.is_active)}>
          {row?.is_active == "0" ? "Active" : "In Active"}
        </span>
      ),
    },
    {
      name: "Actions",
      minWidth: "200px",
      cell: (row) => (
        <>
          <Link
            className="btnview"
            to="/users/view-user"
            state={{ userId: row._id }}
          >
            <Icon icon="tabler:eye"></Icon>
          </Link>
          <Link
            className="btnedit"
            to="/users/edit-user"
            state={{ userId: row._id }}
          >
            <Icon icon="tabler:pencil"></Icon>
          </Link>
          <Link className="btndelete" onClick={() => handleShow(row._id)}>
            <Icon icon="tabler:trash"></Icon>
          </Link>
        </>
      ),
    },
  ];
  const [data] = useState([
    {
      id: 1,
      name: "Maria James",
      imgurl: avatar1,
      email: "maris@gmail.com",
      type: "Google",
      CreatedOn: "15-09-2024",
      status: "Active",
    },
    {
      id: 2,
      name: "Johnson Charles",
      imgurl: avatar2,
      email: "johnson@gmail.com",
      type: "Apple",
      CreatedOn: "20-09-2024",
      status: "In Active",
    },
    {
      id: 3,
      name: "Maria James",
      imgurl: avatar1,
      email: "maris@gmail.com",
      type: "Google",
      CreatedOn: "15-09-2024",
      status: "Active",
    },
    {
      id: 4,
      name: "Johnson Charles",
      imgurl: avatar2,
      email: "johnson@gmail.com",
      type: "Apple",
      CreatedOn: "20-09-2024",
      status: "Active",
    },
    {
      id: 5,
      name: "Maria James",
      imgurl: avatar1,
      email: "maris@gmail.com",
      type: "Google",
      CreatedOn: "15-09-2024",
      status: "Active",
    },
    {
      id: 6,
      name: "Johnson Charles",
      imgurl: avatar2,
      email: "johnson@gmail.com",
      type: "Apple",
      CreatedOn: "20-09-2024",
      status: "In Active",
    },
  ]);
  // Filter data based on search text
  console.log("dataList", dataList);
  const filteredData =
    dataList && dataList.length > 0
      ? dataList.filter(
          (item) =>
            JSON.stringify(item)
              .toLowerCase()
              .indexOf(searchText.toLowerCase()) !== -1
        )
      : [];
  return (
    <React.Fragment>
      <Row>
        <Col lg={12}>
          <Card>
            <Card.Header className="d-flex align-items-center justify-content-between py-4">
              <h5>Users</h5>
            </Card.Header>
            <Card.Body>
              <div className="text-end mb-3">
                <input
                  type="text"
                  placeholder="Search..."
                  className="searchfield"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </div>
              {loading ? (
                <Sentry
                  color="#2B5AAC"
                  size={30}
                  speed={1}
                  animating={true}
                  style={{ marginLeft: "45%" }}
                />
              ) : (
                <DataTable
                  columns={columns}
                  data={filteredData}
                  pagination
                  responsive
                  className="custom-table"
                />
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Delete Modal */}
      <Modal className="modal_Delete" show={show} onHide={handleClose} centered>
        <Modal.Body>
          <div className="modaldelete_div">
            <Icon className="delete_icon" icon="gg:close-o"></Icon>
            <h3>Are You Sure ?</h3>
            <p>You will not be able to recover the deleted record!</p>
          </div>
          <Button
            variant="outline-danger"
            onClick={handleClose}
            className="px-4 me-3"
          >
            Cancel
          </Button>
          <Button
            variant="success"
            className="px-4 min_width110"
            onClick={() => handleDelete()}
          >
            {deleteLoading ? (
              <Spinner animation="border" variant="primary" />
            ) : (
              "Ok"
            )}
          </Button>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}
